<template>
    <form-validation ref="exposedValidation">
        <flex-container :gap="Size.xl">
            <!-- logo -->
            <flex-container>
                <flex-container :screen-sizes="{ laptop: 3 }">
                    <data-group>
                        <data-label>
                            Logo
                        </data-label>
                        <data-value>
                            Upload je logo
                        </data-value>
                    </data-group>
                </flex-container>

                <flex-container :screen-sizes="{ laptop: 7 }">
                    <input-group v-model="form.logo" :schema="mixed().required()">
                        <template v-if="!form.logo" #input>
                            <file-drop-zone-input
                                direct-upload
                                :direct-upload-callback="uploadLogo"
                            />
                        </template>
                        <template v-else #input>
                            <flex-container align-items="center">
                                <flex-container :screen-sizes="{ tablet: 5 }">
                                    <card-normal without-padding>
                                        <flex-container :color="'gray-200'" :padding="Size.sm">
                                            <img
                                                :src="form.logo.url"
                                                style="width: 100%"
                                                alt="Jouw logo"
                                            />
                                        </flex-container>
                                    </card-normal>
                                </flex-container>
                                <button-text :color="'red-500'" @click="deleteLogo">
                                    Verwijderen
                                </button-text>
                            </flex-container>
                        </template>
                    </input-group>
                </flex-container>
            </flex-container>

            <!-- colors -->
            <flex-container>
                <flex-container :screen-sizes="{ laptop: 3 }">
                    <data-group>
                        <data-label>
                            Kleurenschema
                        </data-label>
                        <data-value>
                            Bepaal je kleuren
                        </data-value>
                    </data-group>
                </flex-container>

                <flex-container :screen-sizes="{ laptop: 7 }">
                    <flex-container no-wrap>
                        <input-group v-model="form.primaryColor" :schema="string().required()">
                            <template #label>
                                <text-decorator weight="medium" :size="Size.xs">
                                    Primaire kleur
                                </text-decorator>
                            </template>
                            <template #input>
                                <color-input />
                            </template>
                        </input-group>

                        <input-group v-model="form.secondaryColor" :schema="string().required()">
                            <template #label>
                                <text-decorator weight="medium" :size="Size.xs">
                                    Secundaire kleur
                                </text-decorator>
                            </template>
                            <template #input>
                                <color-input />
                            </template>
                        </input-group>

                        <input-group v-model="form.textColor" :schema="string().required()">
                            <template #label>
                                <text-decorator weight="medium" :size="Size.xs">
                                    Tekst kleur
                                </text-decorator>
                            </template>
                            <template #input>
                                <color-input />
                            </template>
                        </input-group>
                    </flex-container>

                    <flex-container no-wrap>
                        <input-group v-model="form.buttonColor" :schema="string().required()">
                            <template #label>
                                <text-decorator weight="medium" :size="Size.xs">
                                    Knop kleur
                                </text-decorator>
                            </template>
                            <template #input>
                                <color-input />
                            </template>
                        </input-group>

                        <input-group v-model="form.buttonTextColor" :schema="string().required()">
                            <template #label>
                                <text-decorator weight="medium" :size="Size.xs">
                                    Knop tekst kleur
                                </text-decorator>
                            </template>
                            <template #input>
                                <color-input />
                            </template>
                        </input-group>

                        <input-group v-model="form.linkColor" :schema="string().required()">
                            <template #label>
                                <text-decorator weight="medium" :size="Size.xs">
                                    Tekst link kleur
                                </text-decorator>
                            </template>
                            <template #input>
                                <color-input />
                            </template>
                        </input-group>
                    </flex-container>
                </flex-container>
            </flex-container>

            <!-- font -->
            <flex-container>
                <flex-container :screen-sizes="{ laptop: 3 }">
                    <data-group>
                        <data-label>
                            Lettertype
                        </data-label>
                        <data-value>
                            Bepaal de lettertypen
                        </data-value>
                    </data-group>
                </flex-container>

                <flex-container no-wrap :screen-sizes="{ laptop: 7 }">
                    <input-group v-model="form.headingFontName" :schema="object().required()">
                        <template #label>
                            <text-decorator weight="medium" :size="Size.xs">
                                Koppen
                            </text-decorator>
                        </template>
                        <template #input>
                            <font-input />
                        </template>
                    </input-group>

                    <input-group v-model="form.fontName" :schema="object().required()">
                        <template #label>
                            <text-decorator weight="medium" :size="Size.xs">
                                Inhoud
                            </text-decorator>
                        </template>
                        <template #input>
                            <font-input />
                        </template>
                    </input-group>
                </flex-container>
            </flex-container>

            <!-- google tag -->
            <flex-container>
                <flex-container :screen-sizes="{ laptop: 3 }">
                    <data-group>
                        <data-label>
                            Google-tag-ID
                        </data-label>
                        <data-value>
                            Meten is weten
                        </data-value>
                    </data-group>
                </flex-container>

                <flex-container :screen-sizes="{ laptop: 7 }">
                    <flex-container :screen-sizes="{ laptop: 5 }">
                        <input-group v-model="form.googleTagId" :schema="string().nullable()">
                            <template #input>
                                <text-input placeholder="Bijv. G-QCX3G9KSPC" />
                            </template>
                        </input-group>
                    </flex-container>
                </flex-container>
            </flex-container>

            <!-- name -->
            <flex-container>
                <flex-container :screen-sizes="{ laptop: 3 }">
                    <data-group>
                        <data-label>
                            {{ t(`form.name.title`) }}
                        </data-label>
                        <data-value>
                            {{ t(`form.name.description`) }}
                        </data-value>
                    </data-group>
                </flex-container>

                <!-- left side of form -->
                <flex-container :screen-sizes="{ laptop: 7 }">
                    <input-group v-model="form.name" :schema="string().required()">
                        <template #input>
                            <text-input />
                        </template>
                    </input-group>
                </flex-container>
            </flex-container>

            <horizontal-line no-margin />

            <flex-container>
                <flex-container :gap="Size.sm">
                    <text-heading>
                        Optionele URLs
                    </text-heading>
                    <text-description>
                        Hier kun je links plaatsen naar pagina's op je website die je ondersteunen bij marketingcampagnes. Deze links worden automatisch opgenomen in relevante flows
                    </text-description>
                </flex-container>

                <!-- Url website -->
                <flex-container>
                    <flex-container :screen-sizes="{ laptop: 4 }">
                        <data-group>
                            <data-label>
                                Algemeen
                            </data-label>
                            <data-value>
                                Url van website
                            </data-value>
                        </data-group>
                    </flex-container>

                    <flex-container :screen-sizes="{ laptop: 6 }">
                        <input-group v-model="form.websiteUrl" :schema="string().url()">
                            <template #input>
                                <text-input :placeholder="placeholderUrl" />
                            </template>
                        </input-group>
                    </flex-container>
                </flex-container>

                <!-- Url sales -->
                <flex-container>
                    <flex-container :screen-sizes="{ laptop: 4 }">
                        <data-group>
                            <data-label>
                                Info verkoop diensten
                            </data-label>
                            <data-value>
                                Url van verkooppagina
                            </data-value>
                        </data-group>
                    </flex-container>

                    <flex-container :screen-sizes="{ laptop: 6 }">
                        <input-group v-model="form.additionalUrls['sales']" :schema="string().url()">
                            <template #input>
                                <text-input :placeholder="placeholderUrl" />
                            </template>
                        </input-group>
                    </flex-container>
                </flex-container>

                <!-- Url purchase -->
                <flex-container>
                    <flex-container :screen-sizes="{ laptop: 4 }">
                        <data-group>
                            <data-label>
                                Info aankoop diensten
                            </data-label>
                            <data-value>
                                Url van aankooppagina
                            </data-value>
                        </data-group>
                    </flex-container>

                    <!-- left side of form -->
                    <flex-container :screen-sizes="{ laptop: 6 }">
                        <input-group v-model="form.additionalUrls['purchase']" :schema="string().url()">
                            <template #input>
                                <text-input :placeholder="placeholderUrl" />
                            </template>
                        </input-group>
                    </flex-container>
                </flex-container>

                <!-- Url valuation -->
                <flex-container>
                    <flex-container :screen-sizes="{ laptop: 4 }">
                        <data-group>
                            <data-label>
                                Waardebepaling
                            </data-label>
                            <data-value>
                                Url van waardebepalingspagina
                            </data-value>
                        </data-group>
                    </flex-container>

                    <!-- left side of form -->
                    <flex-container :screen-sizes="{ laptop: 6 }">
                        <input-group v-model="form.additionalUrls['valuation']" :schema="string().url()">
                            <template #input>
                                <text-input :placeholder="placeholderUrl" />
                            </template>
                        </input-group>
                    </flex-container>
                </flex-container>

                <!-- Url mortgage -->
                <flex-container>
                    <flex-container :screen-sizes="{ laptop: 4 }">
                        <data-group>
                            <data-label>
                                Hypotheek advies
                            </data-label>
                            <data-value>
                                Url van hypotheekadviespagina
                            </data-value>
                        </data-group>
                    </flex-container>

                    <!-- left side of form -->
                    <flex-container :screen-sizes="{ laptop: 6 }">
                        <input-group v-model="form.additionalUrls['mortgage']" :schema="string().url()">
                            <template #input>
                                <text-input :placeholder="placeholderUrl" />
                            </template>
                        </input-group>
                    </flex-container>
                </flex-container>

                <!-- Url sales -->
                <flex-container>
                    <flex-container :screen-sizes="{ laptop: 4 }">
                        <data-group>
                            <data-label>
                                Contact
                            </data-label>
                            <data-value>
                                Url van contactpagina
                            </data-value>
                        </data-group>
                    </flex-container>

                    <!-- left side of form -->
                    <flex-container :screen-sizes="{ laptop: 6 }">
                        <input-group v-model="form.additionalUrls['contact']" :schema="string().url()">
                            <template #input>
                                <text-input :placeholder="placeholderUrl" />
                            </template>
                        </input-group>
                    </flex-container>
                </flex-container>
            </flex-container>

            <slot name="additionalContent" />
        </flex-container>
    </form-validation>
</template>

<script setup lang="ts">
    import {
        FormValidation,
        type ExposedFormValidationBindings,
        Size,
        CardNormal,
        FlexContainer,
    } from '@keyvue/one-ui';

    import { ref } from 'vue';
    import FontInput from '@/shared/components/input/FontInput.vue';
    import { CompanyLogo, CreateCompanyLogoCommand, DeleteCompanyLogoCommand, LogoId } from '@keyvue/one-api-client';
    import useClient from '@/services/keyvue-api/composables/useClient';
    import { mixed, object, string } from 'yup';
    import { useI18n } from 'vue-i18n';
    import messages from './BrandForm.messages.json';

    const { t } = useI18n({ messages });

    export interface Form {
        name: string,
        logo: CompanyLogo | null,
        primaryColor: string,
        secondaryColor: string,
        textColor: string,
        linkColor: string,
        buttonColor: string,
        buttonTextColor: string,
        headingFontName: { name: string, sizes: number[], fallback: string } | null,
        fontName: { name: string, sizes: number[], fallback: string } | null,
        googleTagId: string | null,
        websiteUrl: string | null,
        additionalUrls: Record<string, string>,
    }

    export interface ExposedBrandForm {
        form: Form,
        setForm: (values: Form) => void,
        formValidation: ExposedFormValidationBindings,
    }

    const { client, currentCompany } = useClient();
    const exposedValidation = ref<ExposedFormValidationBindings | any>();

    const form = ref<Form>({
        name: '',
        logo: null,
        primaryColor: '#F69800',
        secondaryColor: '#1B3D6D',
        textColor: '#000000',
        linkColor: '#0072F6',
        buttonColor: '#F69800',
        buttonTextColor: '#FFFFFF',
        headingFontName: {
            name: 'Nunito Sans',
            sizes: [
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
        fontName: {
            name: 'PT Sans',
            sizes: [
                400,
                500,
                600,
                700,
            ],
            fallback: 'serif',
        },
        googleTagId: '',
        websiteUrl: '',
        additionalUrls: {
            sales: '',
            purchase: '',
            valuation: '',
            mortgage: '',
            contact: '',
        },
    });

    function setForm(values: Form) {
        form.value = values;
    }

    const uploadLogo = async (files: File[]) => {
        const file = files.pop();
        if (!file) {
            return;
        }

        const createLogoCommand = CreateCompanyLogoCommand.create();
        createLogoCommand.companyId = currentCompany.value?.id.value ?? '';
        createLogoCommand.file = file;

        await client.dispatch(createLogoCommand);

        form.value.logo = await client.get(CompanyLogo, createLogoCommand.id);
    };

    const deleteLogo = async () => {
        if (!form.value.logo?.id) {
            return;
        }

        const deleteCommand = new DeleteCompanyLogoCommand(form.value.logo.id as LogoId);
        await client.dispatch(deleteCommand);

        form.value.logo = null;
    };

    const placeholderUrl = 'https://';

    defineExpose({
        form,
        setForm,
        formValidation: exposedValidation,
    });
</script>
